{
    "ComparisonTypeLabel": "Wann:",
    "ComparisonTypeOptionNone": "[Kein Alarm]",
    "ComparisonTypeOptionHigherThan": "Höher als",
    "ComparisonTypeOptionHigherEqual": "Höher\/Gleich",
    "ComparisonTypeOptionLowerThan": "Niedriger als",
    "ComparisonTypeOptionLowerEqual": "Niedriger\/Gleich",
    "ComparisonTypeOptionBetween": "Zwischen",
    "ComparisonTypeOptionEqual": "Gleich",
    "ComparisonTypeOptionNotEqual": "Nicht gleich",
    "ComparisonTypeOptionNotBetween": "Nicht zwischen",
    "ComparisonTypeValue": "Wert:",
    "ComparisonTypeAnd": "Und",
    "AlarmTypeLabel": "Alarmtyp:",
    "AlarmTypeNoSound": "[Keinen Ton]",
    "AlarmTypeAirRaidSiren": "Luftschutzsirenen",
    "AlarmTypeAlarmClock": "Wecker",
    "AlarmTypeDing": "Ding",
    "AlarmTypeDoorChime": "Türgong",
    "AlarmTypeEmergencyServices": "Notdienste",
    "AlarmTypeFastenSeatBelt": "Sicherheitsgurt anlegen",
    "AlarmTypeKerching": "Kerching",
    "AlarmTypePhone": "Telefon",
    "AlarmTypeQuickBleep": "Schneller Piepton",
    "AlarmTypeRadar": "Radar",
    "AlarmTypeSonarPing": "Sonar-Ping",
    "AlarmTypeTarget": "Ziel",
    "AlarmTypeTing": "Ting",
    "AlarmTypeWarningBeep": "Warnton",
    "AlarmTypeWarningBuzzer": "Warnsummer",
    "AlarmRepeatTypeLabel": "Wiedergabetyp:",
    "AlarmRepeatOnce": "Einmal",
    "AlarmRepeatSeconds": "Sekunden",
    "AlarmRepeatPersistent": "Hartnäckig",
    "AlarmRepeatRepeat": "Wiederholen",
    "AlarmSettingsLabel": "Wert:",
    "StatisticAlarm_SectionHeader": "Statistikalarm",
    "NAME": "StatisticAlarm",
    "AlarmType_Air Raid Siren": "Luftangriffssirene",
    "AlarmType_Alarm Clock": "Wecker",
    "AlarmType_Barking": "Bellen",
    "AlarmType_Birds": "Vögel",
    "AlarmType_Cat": "Katze",
    "AlarmType_Chips": "Chips",
    "AlarmType_Coin Drop": "Münzabwurf",
    "AlarmType_Computer": "Computer",
    "AlarmType_Cow": "Kuh",
    "AlarmType_Crowd": "Crowd",
    "AlarmType_Dial Tone": "Freizeichen",
    "AlarmType_Ding": "Ding",
    "AlarmType_Dixie Horn": "Dixie-Horn",
    "AlarmType_Door Chime": "Türklingel",
    "AlarmType_Emergency Services": "Notfalldienste",
    "AlarmType_Fasten Seat Belt": "Sicherheitsgurt anschnallen",
    "AlarmType_Fire Truck": "Feuerwehrauto",
    "AlarmType_Gunshot": "Schusswunde",
    "AlarmType_Hammer": "Hammer",
    "AlarmType_Helicopter": "Hubschrauber",
    "AlarmType_Ice Cubes": "Eiswürfel",
    "AlarmType_Kerching": "Kerching",
    "AlarmType_Laughter": "Lachen",
    "AlarmType_Marbles": "Murmeln",
    "AlarmType_Monkey": "Affe",
    "AlarmType_Morse Code": "Morsealphabet",
    "AlarmType_Night Time": "Nachtzeit",
    "AlarmType_Owl": "Eule",
    "AlarmType_Phone": "Telefon",
    "AlarmType_Pool": "Pool",
    "AlarmType_Pouring Water": "Wasser gießen",
    "AlarmType_Quick Bleep": "Schneller Piepton",
    "AlarmType_Radar": "Radar",
    "AlarmType_Reload": "Neu laden",
    "AlarmType_Rocks Falling": "Fallende Felsen",
    "AlarmType_Rooster": "Hahn",
    "AlarmType_Sawing": "Sägen",
    "AlarmType_School Bell": "Schulglocke",
    "AlarmType_Seaguls": "Seemöwen",
    "AlarmType_Service Bell": "Dienstglocke",
    "AlarmType_SMS": "SMS",
    "AlarmType_Sonar Ping": "Sonar-Ping",
    "AlarmType_Splash": "Spritzwasser",
    "AlarmType_Steam Train": "Dampfzug",
    "AlarmType_Submarine": "U-Boot",
    "AlarmType_Target": "Ziel",
    "AlarmType_Thunder": "Thunder",
    "AlarmType_Ting": "Ting",
    "AlarmType_Tolling Bell": "Läutende Glocke",
    "AlarmType_Trombone": "Posaune",
    "AlarmType_Twinkle": "Twinkle",
    "AlarmType_Walking": "Gehen",
    "AlarmType_Whistling": "Pfeifen",
    "AlarmType_Warning Beep": "Warnton",
    "AlarmType_Warning Buzzer": "Warn-Summer"
}